import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { setupFaIconLibrary, theme, Toast } from '@acp/core-ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Hotjar from '@hotjar/browser';
import { routes } from './pages/routes';
import { RootErrorBoundary } from './components/errors/root-error-boundary';

import './styles/brand-fonts.scss';
import './styles/reset.scss';
import './styles/svg-overflow-visible.scss';
import './styles/react-day-picker.scss';
import { queryClient } from './query-client';
import { setupGoogleAnalytics } from './hooks/use-google-analytics';
import { setupDatadog } from './hooks/use-datadog';

function setupHotjar() {
    if (import.meta.env.VITE_PUBLIC_HOTJAR_SITE_ID !== undefined) {
        const siteId = import.meta.env.VITE_PUBLIC_HOTJAR_SITE_ID;
        const hotjarVersion = 6;

        Hotjar.init(siteId, hotjarVersion);
    }
}

setupDatadog();
setupGoogleAnalytics();
setupHotjar();
setupFaIconLibrary();

const root = ReactDOM.createRoot(
    document.getElementById('root')!
);
const router = createBrowserRouter(routes);

root.render(
    <StrictMode>
        <RootErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <ChakraProvider
                    resetCSS
                    theme={theme}
                    toastOptions={{ defaultOptions: { render: Toast } }}
                >
                    <Box display="flex" flexDirection="column" minH="100vh">
                        <RouterProvider router={router} />
                        <div
                            data-cy-ready="1"
                            data-cy-env={import.meta.env.VITE_PUBLIC_APP_ENV}
                            hidden
                        />
                    </Box>
                </ChakraProvider>
                <ReactQueryDevtools
                    initialIsOpen={false}
                    buttonPosition="bottom-right"
                />
            </QueryClientProvider>
        </RootErrorBoundary>
    </StrictMode>
);
